import React from "react";
import { useSelector } from "react-redux";
import clevertap from "clevertap-web-sdk";
import cn from "classnames";
// import { Link } from "react-router-dom";
import {Link, NavLink} from "react-router-dom";
import styles from "./Main.module.sass";
import style from "../../Auth/SignUp/Form/Form.module.sass";
import Cards from "./Cards";
import Video from "../../../components/Video"
import session_manager from "../../../utils/SessionManager";
import Icon from "../../../components/Icon";
import { useTranslation } from "react-i18next";
import {motion} from "framer-motion"
import InformationCircle from 'react-ionicons/lib/InformationCircle';
import Google from "../../../components/SocialAuth/Google"
import LazyLoad from "react-lazyload";
// import ScrollButton from "../../../components/ScrollButton";

/**
 * @param scrollToRef
 * @returns {Element}
 * @constructor
 */
const Main = ({ scrollToRef }) => {
    const { t } = useTranslation();

    const accountInfo = useSelector(state => state.user.account_info);

    /**
     *
     */
    return (
        <>
          <div className="sectionhero moremargin" >
            <div className="container w-container ">
              <LazyLoad offset={200}>
                <img src="/images/home/phone.png" className="absolute bottom-2 md:top-20 right-0 md:w-2/3  -z-10" fetchPriority="high"  />
              </LazyLoad>
           
            {/* <img src="/images/home/confetti.svg" width={"100%"} className={styles.confetti}/> */}
              <div className="contenthero">
                
                <div className="flex flex-col md:flex-row " style={{gap:"5em"}}>
                    <div className="order-last text-center  md:w-3/5 ">
                    
                      <div className="relative">
                        <LazyLoad offset={200}>
                        <img src="/images/home/main-banner.png" fetchPriority="high" />
                        </LazyLoad>
                      </div>
                  <LazyLoad offset={200}>
                  <img
                            src="/images/logo-dark.svg"
                            loading="lazy"
                            width={100}
                            alt=""
                            className="md:hidden"
                       />
                  </LazyLoad>
                      
                    </div>
                    <div className="md:w-2/5">
                        <motion.h2
                            initial={{opacity: 0, y: -30}}
                            animate={{opacity: 1, y: 0}}
                            transition={{delay: 0.2, duration: 0.5}}
                            exit={{opacity: 0}}
                            className={cn("", styles.hero)}
                        >
                          {t(`home.main.trade`)}
                        </motion.h2>
                        {/* <motion.h1
                            initial={{opacity: 0, y: -30}}
                            animate={{opacity: 1, y: 0}}
                            transition={{delay: 0.2, duration: 0.5}}
                            exit={{opacity: 0}}
                            className={cn("", styles.reward)}
                        >
                        50<span className="text-4xl"> $USDT</span>
                        </motion.h1>
                        <NavLink to="/campaign/beta-testing-campaign" onClick={() => {
                          clevertap.event.push("banner_in_homepage_clicked", {
                            userId: accountInfo ? accountInfo.profile.id : null,
                          });
                        }}>
                          <span className="flex gap-1 opacity-70 pb-3 text-white">
                            <InformationCircle
                              color={'#ffffff'}
                              height="25px"
                              width="25px"
                            />
                            {t(`home.main.more`)}
                          </span>
                        </NavLink> */}
                      <p  className={cn("text-white text-lg",styles.info)}>{t(`home.main.info`)}</p>
                {/* <div className="auth-links-hero">
                  {!session_manager.isLoggedIn() && (
                    <div >
                     <motion.a
                        id="rsvp"
                        href="/registration"
                        className={cn("buttonhero w-button",styles.promo)}
                        initial={{opacity: 0, y: 0}}
                        animate={{opacity: 1, y: 10}}
                    >
                       {t(`home.main.started`)}&nbsp;→
                    </motion.a>
                      <div>
                        
                        <br/>
                        <div className={styles.authBtns}><span>{t(`home.main.continue`)}</span></div>
                        <div className={style.btns}>
                          <div className={style.gapple}>
                            <button
                              type='button'
                              className={cn("icon", styles.icon)}
                              // onClick={() => googleLogin()}
                            >
                              <Icon name="google" size="16"/>
                            
                            </button>
                          </div>
                        
                        </div>
                      </div>
                    </div>
                  )}
               
                </div> */}

                    <motion.div id="rsvp" initial={{opacity: 0, y: 0}} animate={{opacity: 1, y: 10}}>
                        <NavLink to="/registration" className={cn("buttonhero w-button", styles.promo)}>{t(`home.main.starttrading`)}&nbsp;→</NavLink>
                    </motion.div>
                    </div>
                </div>
               
                <div className="w-embed">
                  <input
                      type="hidden"
                      id="gclid_field"
                      name="gclid_field"
                      defaultValue=""
                  />
                </div>
              </div>
            </div>
          </div>
          {/* <div className={cn("section", styles.main)}>
            <div className={cn("container", styles.container)}>
                <div className={styles.wrap}>
                    <h1 className={cn("h1", styles.title)}>{t('home.main.title')}</h1>
                    <div className={styles.text}>{t('home.main.titleText')}</div>
                </div>
                <div className={styles.bg}>
                    <Video src="/videos/exzi-light.m4v" srcDark="/videos/exzi.m4v" width={"100%"} />
                </div>
                <h1>{t('home.main.h1')}</h1>
                <div className={styles.text}>{t('home.main.h1Text')}</div>
            </div>
        </div> */}
        </>
    );
};

export default Main;
